import React, { PureComponent, Fragment } from 'react';
import { Skeleton } from '@material-ui/lab';
import DataCard from 'shared/components/DataCard';
import BarChart from 'shared/components/BarChart';
import { isAfter, isBefore } from "date-fns";


const classes = {
    cardMargin: {
        paddingTop: 15,
        paddingBottom: 15,
    }
}

const SkeletonCard = ({ width, height }) => (
    <div style={classes.cardMargin}>
        <Skeleton style={{ borderRadius: 4 }} variant="rect" width={width} height={height} />
    </div>
)

const filterByDate = (value, begin, end) => {
  if (begin && end) {
      // both have a value
      return isAfter(value, begin) && isBefore(value, end);
  } else if (begin) {
    // console.log(value, begin);
      // there is a value for begin
      return isAfter(value, begin);
  } else if (end) {
      // there is a value for end
      return isBefore(value, end);
  }
  return true;
};

const filterByAmi = (obj, filters, filterKey) => {
  const itemKeys = Object.keys(obj)
  // eslint-disable-next-line no-unused-vars
  for (const itemKey of itemKeys) {
      if (itemKey.startsWith('ami')) {
          if (+(itemKey.split('_')[1]) <= filters[filterKey]) {
              if (!!obj[itemKey]) {
                  return true;
              }
          }
      }
  }
  return false;
}

class SnapshotLeftTable extends PureComponent {

    formatData = (data) => {
        
        const keys = Object.keys(data);
        return keys.map(item => ({ 'ordinals': item, 'count': data[item] }))
    }

    formatDataFromHousingToSnapshot = (housingData, filters) =>{

        var src = housingData['features']

        var fundingdict = {}
        var riskdict = {}
        riskdict["Expiring within 6 months"] = 0
        riskdict["Expiring within 1 year"] = 0
        riskdict["Expiring within 3 years"]  = 0
        riskdict["Expiring within 5 years"] = 0


        var stewarding = {}
        var cnt = 0

        src.forEach(property => {

            if (property["UnitsSub"] == null){
                property["UnitsSub"] = 0
            }

            const filterSubsidies = property['properties']['subsidies'].filter((item, i) => 
              filters 
                ? Object.keys(filters).every(key => {
                  if (!filters[key]) return true;
                  if (key === "SubStart") {
                      return filterByDate(new Date(item[key]), filters[key][0], filters[key][1])
                  }
                  if (key === "SubEnd") {
                      return filterByDate(new Date(item[key]), filters[key][0], filters[key][1])
                  }
                  // if (key === "RiskUnits") {
                  //     return filterByRiskUnits(item, filters, key)
                  // }
                  if (key === "Funding") {
                      const filterIsArray = Array.isArray(filters[key]);
                      const fundingString = item[key].join(',');

                      if (fundingString) {
                        if (!filterIsArray) {
                          return fundingString.search(filters[key]) !== -1
                        } 
                        const booleanArray = []
                        filters[key].forEach(value => booleanArray.push( fundingString.search(value) !== -1))
                        return !filterIsArray ? false : booleanArray.includes(true);
                      }
                      return false;
                    }
                  if (key === "UnitAMI") {
                      return filterByAmi(item, filters, key)
                  }
                  if (key === "tenantType"){
                      const filterIsArray = Array.isArray(filters[key])
                      // console.log(filters[key]);
                      // console.log(item[key])
                      if (item[key]) {
                        if (!filterIsArray) {
                          return item[key].search(filters[key]) !== -1
                        }
                        const booleanArray = []
                        filters[key].forEach(value => booleanArray.push( item[key].search(value) !== -1))
                        return !filterIsArray ? false : booleanArray.includes(true);
                      }
                      return false;
                  }
                  return item[key].search(filters[key]) !== -1
                })
              : true
            )
            const subsidiesByStardingAgency = {};
            const subsidiesByFundingSource = {};
            const subsidiesByRiskExp = {};
            const maxSubUnitsForProperty = Math.max(...filterSubsidies.map(subsidy => subsidy['UnitsSub']).filter(numUnits => !isNaN(parseInt(numUnits))))
            
            cnt += maxSubUnitsForProperty

            filterSubsidies.forEach(subsidy => {
              const stewardingAgencyArray = subsidy['Stewarding'].split(', ');
              const fundingSourceArray = subsidy['Funding'][0] ? subsidy['Funding'][0].split(', ') : ['n/a'];
              
              stewardingAgencyArray.forEach( stewardingAgency =>
                subsidiesByStardingAgency[stewardingAgency]
                  ? subsidiesByStardingAgency[stewardingAgency].push(subsidy)
                  : subsidiesByStardingAgency[stewardingAgency] = [subsidy]
              )
              
              fundingSourceArray.forEach(fundingSource => { 
                const key = fundingSource.includes('TAD') 
                  ? 'TAD'
                  : fundingSource.includes('AH ')
                    ? 'Atlanta Housing'
                    : fundingSource;

                subsidiesByFundingSource[key]
                  ? subsidiesByFundingSource[key].push(subsidy)
                  : subsidiesByFundingSource[key] = [subsidy]
              })

              subsidiesByRiskExp[subsidy['RiskUnits']]
                ? subsidiesByRiskExp[subsidy['RiskUnits']].push(subsidy)
                : subsidiesByRiskExp[subsidy['RiskUnits']] = [subsidy]
            })

            Object.entries(subsidiesByStardingAgency)
              .filter(([key, value]) => key !== 'n/a')
              .forEach(([key,subsidiesArray]) => {
                const maxSubUnits = Math.max(...subsidiesArray.map(subsidy => subsidy['UnitsSub']).filter(numUnits => !isNaN(parseInt(numUnits))))
                stewarding[key]
                  ? stewarding[key] += maxSubUnits
                  : stewarding[key] = maxSubUnits
              });

            Object.entries(subsidiesByFundingSource)
              .filter(([key, value]) => key !== 'n/a')
              .forEach(([key,subsidiesArray]) => { 
                const maxSubUnits = Math.max(...subsidiesArray.map(subsidy => subsidy['UnitsSub']).filter(numUnits => !isNaN(parseInt(numUnits))))
                fundingdict[key]
                  ? fundingdict[key] += maxSubUnits
                  : fundingdict[key] = maxSubUnits
              });

            Object.entries(subsidiesByRiskExp)
              .filter(([key, value]) => key !== 'n/a')
              .forEach(([key,subsidiesArray]) => { 
                const maxSubUnits = Math.max(...subsidiesArray.map(subsidy => subsidy['UnitsSub']).filter(numUnits => !isNaN(parseInt(numUnits))))
                riskdict[key]
                  ? riskdict[key] += maxSubUnits
                  : riskdict[key] = maxSubUnits
              })
        })
        
        var res = {}

        res["funding"] = Object.fromEntries(Object.entries(fundingdict).sort((a,b) => b[1] - a[1]))
        res["risk"] = Object.fromEntries(Object.entries(riskdict).filter(([key, value]) => value > 0))
        res["stewarding"] = stewarding
        res["total"] = cnt
        res["totalProp"] = src.length

        return res
    }

    render() {
        const { housingData, formattedFilters } = this.props;
        const subsidyFilters = formattedFilters
          ? formattedFilters['Subsidy']
          : null

        var data = this.formatDataFromHousingToSnapshot(housingData, subsidyFilters );
        // const data = null;
        const isFetching = false;
        const total = !!data && data.total
        const totalProp = !!data && data.totalProp
        const fundingSource = !!data && this.formatData(data.funding);
        const atRiskSource = !!data && this.formatData(data.risk);
        const stewardingSource = !!data && this.formatData(data.stewarding);

        return (
            <div className="extra-padding-v">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-5 col-xl-4">
                            {isFetching && (
                                <Fragment>
                                    <SkeletonCard width={'100%'} height={115} />
                                    <SkeletonCard width={'100%'} height={125} />
                                    <SkeletonCard width={'100%'} height={125} />
                                </Fragment>
                            )}
                            {!!total && (
                                <Fragment>
                                    {/* <DataCard
                                        special
                                        value="Snapshot shows the entire dataset. Filters do not affect charts. These calculations may not be exact and depend on numbers provided by local agencies."
                                    /> */}
                                    <DataCard
                                        title="Data Last Updated"
                                        value={(new Date()).toLocaleDateString()}
                                        lg
                                    />
                                    <DataCard
                                        title="Number Of Subsidized Units"
                                        value={total.toLocaleString()}
                                        lg
                                    />
                                    <DataCard
                                        title="Number Of Properties"
                                        value={totalProp.toLocaleString()}
                                        lg
                                    />
                                </Fragment>
                            )}

                        </div>
                        <div className="col-7 col-xl-8">
                            {isFetching && (
                                <SkeletonCard width={'100%'} height={426} />
                            )}
                            {!!fundingSource && (
                                <DataCard
                                    title="Number of Units Per Funding Source"
                                    content={(
                                        <BarChart
                                            tiltedLabels
                                            source={fundingSource}
                                            height={300}
                                            color="rgb(31, 120, 180)"
                                            id="funding"
                                            numberOfTicks={6}
                                            paddingBetweenBars={0.26}
                                        />
                                    )}
                                />
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            {isFetching && (
                                <SkeletonCard width={'100%'} height={426} />
                            )}
                            {!!atRiskSource && (
                                <DataCard
                                    title="Number of Units At-Risk of Losing Subisdy"
                                    content={(
                                        <BarChart
                                            source={atRiskSource}
                                            height={300}
                                            color="rgb(51, 175, 168)"
                                            id="atRisk"
                                            numberOfTicks={5}
                                            paddingBetweenBars={0.5}
                                        />
                                    )}
                                />
                            )}
                        </div>
                        <div className="col-6">
                            {isFetching && (
                                <SkeletonCard width={'100%'} height={426} />
                            )}
                            {!!stewardingSource && (
                                <DataCard
                                    title="Number of Units Per Stewarding Agency"
                                    content={(
                                        <BarChart
                                            source={stewardingSource}
                                            height={300}
                                            color="rgb(202, 178, 213)"
                                            id="stewarding"
                                            numberOfTicks={5}
                                            paddingBetweenBars={0.3}
                                        />
                                    )}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SnapshotLeftTable